import { select } from 'redux-saga/effects'

import { selectActiveDocumentChunkIds } from '../../slices/documents'
import { GeometryGroup } from '../../slices/geometry'
import { selectDrawableGroups } from '../2D/handleToggleDrawableGroups'

// Hidden only if every active chunk with an explicit toggle marks it hidden -- visible on any
// one active overlay keeps it shown.
function isGroupHiddenAcrossActiveChunks(isActive: Record<number, boolean>, activeChunkIds: number[]): boolean {
    const relevantToggles = activeChunkIds.reduce<boolean[]>((toggles, chunkId) => {
        const toggle = isActive[chunkId]

        if (toggle !== undefined) toggles.push(toggle)

        return toggles
    }, [])

    return relevantToggles.length > 0 && relevantToggles.every((toggle) => toggle === false)
}

export function* getHiddenAndVisibleGroups() {
    // selectDrawableGroups already covers every active chunk, so no separate base-home merge needed.
    const allDrawableGroupsOnFloor: GeometryGroup[] = yield select(selectDrawableGroups)
    const activeChunkIds: number[] = yield select(selectActiveDocumentChunkIds)

    if (!activeChunkIds.length) return { hiddenDrawableGroupIds: [], visibleDrawableGroupIds: [] }

    const [hiddenDrawableGroupIds, visibleDrawableGroupIds] = allDrawableGroupsOnFloor.reduce(
        ([hidden, visible]: [number[], number[]], drawableGroup: GeometryGroup): [number[], number[]] =>
            isGroupHiddenAcrossActiveChunks(drawableGroup.isActive, activeChunkIds)
                ? [[...hidden, drawableGroup.id], visible]
                : [hidden, [...visible, drawableGroup.id]],
        [[], []]
    )

    return { hiddenDrawableGroupIds, visibleDrawableGroupIds }
}
